import { useContext } from 'react';
import { AppContext } from '../../context/Contexte';

const Header = ({ weight, prefer }) => {
  const { t } = useContext(AppContext);
  return (
    <>
      <div className="UserChoose">
        <p>
          {t('weight')} : {weight}kg
        </p>
        <p> {t(prefer)} </p>
      </div>
      <p>{t('recommendation_text')}</p>
    </>
  );
};

export default Header;
